import React from 'react';

import './styles.scss';

const HeadingContent = ({ children }) => <h2 className="blog-heading-content">{children}</h2>

export default HeadingContent;
